import React, { useState, useEffect } from 'react';
import {
  LIMIT_SIDE_PX,
  MAX_VALUE_WIDTH_HEIGHT_PX,
  MIN_VALUE_HEIGHT_PX,
  MIN_VALUE_WIDTH_PX,
  DEFAULT_WIDTH_PX,
  DEFAULT_HEIGHT_PX,
} from '../constansts';
import { SelectedAdUnit } from '../types/AdUnitDto';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import _ from 'loadsh';
import WIDGET_SIZE from '../enums/widgetSize';
import usePrevious from './usePrevious';
import { isMobile } from '../services/wixServices';

declare global {
  interface Window {
    Wix: any;
  }
}
const useLimitResize = (
  adUnitByCompId: SelectedAdUnit,
  selectedAd: SelectedAdUnit | undefined,
  selectedAdtriggered: boolean,
) => {
  const [width, setW] = useState(window.innerWidth);
  const [height, setH] = useState(window.innerHeight);
  const prevWidth = usePrevious(width);
  const prevHeight = usePrevious(height);
  const resizeComponent = (w: number, h: number) => {
    console.log('32 rc', w, h);
    if (window.Wix.Utils.getViewMode() !== 'site') {
      if (isMobile()) {
        window.Wix.Settings.resizeComponent({
          width: 300,
          height: 250,
        });
      } else {
        setTimeout(() => {
          window.Wix.Settings.resizeComponent({
            width: w,
            height: h,
          });
        }, 500);
      }
    }
  };

  useEffect(() => {
    const responsiveWithLimit = () => {
      console.log(
        'responsiveWithLimit',
        adUnitByCompId,
        selectedAd,
        selectedAdtriggered,
        width,
        height,
      );
      if (width !== 0 && height !== 0) {
        width < MIN_VALUE_WIDTH_PX &&
          resizeComponent(MIN_VALUE_WIDTH_PX, height);
        height < MIN_VALUE_HEIGHT_PX &&
          resizeComponent(width, MIN_VALUE_HEIGHT_PX);

        if (prevWidth !== width) {
          if (width > MAX_VALUE_WIDTH_HEIGHT_PX && height <= LIMIT_SIDE_PX) {
            resizeComponent(MAX_VALUE_WIDTH_HEIGHT_PX, height);
          }
          if (width > LIMIT_SIDE_PX && height > LIMIT_SIDE_PX) {
            resizeComponent(LIMIT_SIDE_PX, height);
          }
        }

        if (prevHeight !== height) {
          if (height > MAX_VALUE_WIDTH_HEIGHT_PX && width <= LIMIT_SIDE_PX) {
            resizeComponent(width, MAX_VALUE_WIDTH_HEIGHT_PX);
          }
          if (height > LIMIT_SIDE_PX && width > LIMIT_SIDE_PX) {
            resizeComponent(width, LIMIT_SIDE_PX);
          }
        }
      }
    };
    const limitResize = () => {
      setW(window.innerWidth);
      setH(window.innerHeight);
      isMobile() && resizeComponent(DEFAULT_WIDTH_PX, DEFAULT_HEIGHT_PX);
      if (
        !selectedAdtriggered &&
        (!adUnitByCompId || (!adUnitByCompId && !selectedAd))
      ) {
        console.log(
          '90 limitResize',
          selectedAdtriggered,
          adUnitByCompId,
          selectedAd,
        );
        responsiveWithLimit();
      } else {
        const currentHeight =
          selectedAd !== undefined
            ? selectedAd?.dimensions?.height
            : adUnitByCompId?.dimensions?.height;

        const currentWidth =
          selectedAd !== undefined
            ? selectedAd?.dimensions?.width
            : adUnitByCompId?.dimensions?.width;
        const currentSize =
          selectedAd !== undefined ? selectedAd?.size : adUnitByCompId?.size;
        currentSize === WIDGET_SIZE.fixed &&
          resizeComponent(currentWidth, currentHeight);
        responsiveWithLimit();
      }
    };
    window.addEventListener('resize', limitResize, false);
    return () => window.removeEventListener('resize', limitResize);
  }, [
    adUnitByCompId,
    selectedAd,
    selectedAdtriggered,
    width,
    height,
    prevWidth,
    prevHeight,
  ]);
};
export default useLimitResize;
